export const DO_NOT_IMPORT = "__DO_NOT_IMPORT__";

export const STEPS = ["Map entity", "Map columns", "Data validation"];

export const FLOW_STEP_INDEX = {
    ChooseEntity: 1,
    DefineMapping: 2,
    FixData: 3,
};

export const KPI_BORDER_COLORS = ["warning.main", "success.main", "text.disabled", "primary.main"];

export const AI_CONFIDENCE_GRADIENT = "linear-gradient(to right, #f59e0b, #8b5cf6)";

export const DATATYPE_TO_FIELD_TYPE = {
    DECIMAL: "number", NUMERIC: "number", INTEGER: "number", INT: "number",
    BIGINT: "number", FLOAT: "number", DOUBLE: "number", REAL: "number",
    VARCHAR: "text", TEXT: "text", CHAR: "text", STRING: "text",
    DATE: "date", DATETIME: "date", TIMESTAMP: "date",
};
